import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';//样式文件需要单独引入
Vue.use(ElementUI);


//全局引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts=echarts

import 'animate.css';


// 动态加载数据
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)



import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.config.productionTip = false;


import left from './components/left.vue'
Vue.component("LeftList",left)
import leftTwo from './components/leftTwo.vue'
Vue.component("leftTwoList",leftTwo)
import right from './components/right.vue'
Vue.component("RightList",right)
import rightTwo from './components/rightTwo.vue'
Vue.component("rightTwoList",rightTwo)
import top from './components/top.vue'
Vue.component("TopList",top)
import loader from './components/loader.vue'
Vue.component("LoaderList",loader)
import xianyu from './components/xianyu.vue'
Vue.component("Xianyu",xianyu)
// import map from './components/map.vue'
// Vue.component("MapList",map)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
